import { ref, Ref, watch } from 'vue'
import useResizeObserver from '@app/shared/vue/composables/use-resize-observer'

/**
 * A Vue composable that uses the size of an element to check whether it has
 * been truncated, and either populates or clears a string ref based on that
 * info.
 * @param containerRef - A ref to the element to observer
 * @param text - The content of the ref if the element has been truncated
 * @returns A ref containing either the given text or the empty string
 */
export default function useDynamicTooltip(
  containerRef: Ref<HTMLElement | null>,
  text: string
): Ref<string> {
  const tooltip = ref<string>('')
  const { entries } = useResizeObserver(containerRef)
  watch(entries, () => {
    if (entries.value.length === 0) {
      return
    }

    const element = entries.value[0].target as HTMLElement
    if (element.offsetWidth < element.scrollWidth) {
      tooltip.value = text
    } else {
      tooltip.value = ''
    }
  })
  return tooltip
}
